import React from 'react';
import { Package, DollarSign, TrendingUp, AlertCircle } from 'lucide-react';
import Icon from '../../../components/AppIcon';


const MerchandiseStats = ({ stats }) => {
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    })?.format(amount);
  };

  const statsCards = [
    {
      title: 'Total Items',
      value: stats?.total || 0,
      icon: Package,
      color: 'blue',
      description: 'Total merchandise items'
    },
    {
      title: 'Total Inventory Value',
      value: formatCurrency(stats?.totalValue || 0),
      icon: DollarSign,
      color: 'green',
      description: 'Total value of all inventory'
    },
    {
      title: 'Total Stock',
      value: stats?.totalStock || 0,
      icon: TrendingUp,
      color: 'purple',
      description: 'Total units in stock'
    },
    {
      title: 'Out of Stock',
      value: stats?.byStatus?.out_of_stock || 0,
      icon: AlertCircle,
      color: 'red',
      description: 'Items requiring restock'
    }
  ];

  const getColorClasses = (color) => {
    const colors = {
      blue: 'bg-blue-500 text-blue-100',
      green: 'bg-green-500 text-green-100',
      purple: 'bg-purple-500 text-purple-100',
      red: 'bg-red-500 text-red-100'
    };
    return colors?.[color] || colors?.blue;
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-6">
      {statsCards?.map((stat, index) => {
        const Icon = stat?.icon;
        return (
          <div key={index} className="bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 p-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-gray-600 dark:text-gray-400">
                  {stat?.title}
                </p>
                <p className="text-2xl font-bold text-gray-900 dark:text-white mt-1">
                  {stat?.value}
                </p>
                <p className="text-sm text-gray-500 dark:text-gray-500 mt-1">
                  {stat?.description}
                </p>
              </div>
              <div className={`p-3 rounded-full ${getColorClasses(stat?.color)}`}>
                <Icon className="h-6 w-6" />
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default MerchandiseStats;